import React from "react";
import { Box } from "@mui/material";
import { InfoIcon } from "assets";
import { COLORS } from "components";

const infoBoxSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1,
  mb: "12px",
  p: 1.5,
  backgroundColor: "#E5EAF3",
  fontWeight: 600,
  borderRadius: 1,
};

export interface InfoMessageBoxProps {
  children: React.ReactNode;
}

/**
 * Info message box with icon.
 */
export const InfoMessageBox = ({ children }: InfoMessageBoxProps) => (
  <Box sx={infoBoxSx}>
    <InfoIcon color={COLORS.Romance} height="20px" width="20px" style={{ flexShrink: 0 }} />
    {children}
  </Box>
);
